<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader class="d-flex justify-content-between align-items-center">
                    <strong>Тригерные рассылки</strong>
                    <CButton
                        color="primary"
                        size="sm"
                        :to="'/trigger-campaigns/create'">
                        Создать рассылку
                    </CButton>
                </CCardHeader>
                <CCardBody>
                    <div class="table__preloader" v-if="loading">
                        <CSpinner color="primary"/>
                    </div>
                    <div v-show="!loading">
                        <CDataTable
                            hover
                            :items="campaigns"
                            :fields="fields">
                            <template #id="data">
                                <td>
                                    <CLink :to="`/trigger-campaigns/${data.item.id}`">{{
                                        data.item.id
                                    }}</CLink>
                                </td>
                            </template>
                            <template #name="data">
                                <td>
                                    <CLink :to="`/trigger-campaigns/${data.item.id}`">{{
                                        data.item.name || 'Без названия'
                                    }}</CLink>
                                </td>
                            </template>
                            <template #segment_name="data">
                                <td>
                                    {{ data.item.segment_name || 'Все пользователи' }}
                                </td>
                            </template>
                            <template #trigger_type="data">
                                <td>
                                    {{ getTriggerTypeLabel(data.item.trigger_type) }}
                                </td>
                            </template>
                            <template #trigger_days="data">
                                <td>
                                    <span v-if="data.item.trigger_type !== 'cart_abandoned' && data.item.trigger_type !== 'checkout_abandoned'">
                                        {{ data.item.trigger_days }} дн.
                                    </span>
                                    <span v-else>
                                        {{ data.item.trigger_hours }} ч.
                                    </span>
                                </td>
                            </template>
                            <template #send_time="data">
                                <td>
                                    <span v-if="data.item.send_schedule">
                                        <code class="small">{{ data.item.send_schedule }}</code>
                                        <div class="text-muted small">
                                            {{ getScheduleDescription(data.item.send_schedule) }}
                                        </div>
                                    </span>
                                    <span v-else>
                                        {{ data.item.send_time }}
                                    </span>
                                </td>
                            </template>
                            <template #enabled="data">
                                <td>
                                    <CBadge :color="getBadgeColor(data.item.enabled)">
                                        {{ data.item.enabled ? "Активна" : "Неактивна" }}
                                    </CBadge>
                                </td>
                            </template>
                            <template #created_at="data">
                                <td>
                                    {{ formatDate(data.item.created_at) }}
                                </td>
                            </template>
                            <template #actions="data">
                                <td>
                                    <CButton
                                        color="info"
                                        size="sm"
                                        class="mr-2"
                                        :to="`/trigger-campaigns/${data.item.id}/edit`">
                                        Редактировать
                                    </CButton>
                                    <CButton
                                        color="primary"
                                        size="sm"
                                        class="mr-2"
                                        :to="`/trigger-campaigns/${data.item.id}`">
                                        Открыть
                                    </CButton>
                                    <CButton
                                        color="danger"
                                        size="sm"
                                        @click="deleteCampaign(data.item.id)">
                                        Удалить
                                    </CButton>
                                </td>
                            </template>
                        </CDataTable>
                        <CPagination
                            :active-page.sync="activePage"
                            class="mt-4"
                            :pages="totalPages"
                            align="center"
                        />
                    </div>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    const { formatDate } = require('../../utils/views');

    export default {
        name: 'TriggerCampaigns',

        data() {
            return {
                loading: true,
                campaigns: [],
                totalPages: 1,
                fields: [
                    { key: 'id', label: 'ID', _classes: 'font-weight-bold' },
                    { key: 'name', label: 'Название' },
                    { key: 'segment_name', label: 'Сегмент' },
                    { key: 'trigger_type', label: 'Тип триггера' },
                    { key: 'trigger_days', label: 'Период' },
                    { key: 'send_time', label: 'Расписание' },
                    { key: 'enabled', label: 'Статус' },
                    { key: 'created_at', label: 'Дата создания' },
                    { key: 'actions', label: 'Действия' }
                ],
                triggerTypes: {
                    'registration': 'После регистрации',
                    'last_order': 'После последнего заказа',
                    'cart_abandoned': 'Брошенная корзина',
                    'checkout_abandoned': 'Брошенная оплата'
                }
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                    await this.fetch();
                }
            }
        },

        async mounted() {
            await this.fetch();
            this.loading = false;
        },

        methods: {
            formatDate,
            
            getBadgeColor(status) {
                return status ? 'success' : 'secondary';
            },

            getTriggerTypeLabel(type) {
                return this.triggerTypes[type] || type;
            },

            getScheduleDescription(schedule) {
                const scheduleDescriptions = {
                    '0 9-18 * * *': 'Каждый час 9:00-18:00',
                    '0 10-20 * * *': 'Каждый час 10:00-20:00',
                    '0 */2 * * *': 'Каждые 2 часа',
                    '0 9,12,15,18 * * *': '9:00, 12:00, 15:00, 18:00',
                    '30 10-16 * * *': 'В 30 мин. 10:30-16:30',
                    '0 9-18 * * 1-5': 'Каждый час 9:00-18:00 (пн-пт)'
                };
                return scheduleDescriptions[schedule] || 'Пользовательское';
            },

            async fetch() {
                try {
                    const response = await Vue.axios.get('/trigger-campaigns', {
                        params: {
                            page: this.activePage,
                            limit: 20
                        }
                    });
                    this.campaigns = response.data.data;
                    this.totalPages = response.data.pagination.totalPages;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки тригерных рассылок.');
                    console.error(err);
                }
            },

            async deleteCampaign(campaignId) {
                if (confirm('Вы уверены, что хотите удалить эту тригерную рассылку?')) {
                    try {
                        await Vue.axios.delete(`/trigger-campaigns/${campaignId}`);
                        this.$root.$emit('showSuccess', 'Тригерная рассылка удалена.');
                        await this.fetch();
                    } catch (err) {
                        this.$root.$emit('showError', 'Ошибка удаления тригерной рассылки.');
                        console.error(err);
                    }
                }
            }
        }
    };
</script>
